import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { LOCALE_ID, inject } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, HttpClient } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client';

import { environment } from '@app/environment';
import { DemoozDateService } from '@demooz/services';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
    new TranslateHttpLoader(http, './assets/i18n/', '.json');

registerLocaleData(localeFr);

DemoozDateService.InitMomentLocale();

bootstrapApplication(AppComponent, {
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideIonicAngular({
            mode: 'md',
            innerHTMLTemplatesEnabled: true
        }),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideHttpClient(),
        provideTranslateService({
            defaultLanguage: 'fr',
            /*loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },*/
        }),
        provideHttpClient(), provideApollo(() => {
            const httpLink = inject(HttpLink);
            return {
                link: httpLink.create({
                    uri: environment.URL_API_BACKEND_GRAPHQL,
                    withCredentials: true
                }),
                cache: new InMemoryCache(),
                
            };
        })
    ],
});
